import React from "react"

import styles from "./index.module.scss"

export type CloseButtonProps = {
  onClick: () => void
}

const CloseButton: React.FC<CloseButtonProps> = ({ onClick }) => (
  <button className={styles.closeButton} onClick={onClick} />
)

export default CloseButton
